import { addZhiniaoPrefix } from '@utils/SSOHelper'
import Store from 'store'
import axios from '../../axios'
import UserStore from '../../../stores/UserStore'

const sessionInfo = Store.get('sessionInfo') || {}
const { userId = '' } = sessionInfo

interface IShortVideo {
  // 当前页面
  pageNo: number
  pageSize: number
  keyword: string
  module?: any
}

export default {
  searchList: (
    sid: string,
    pageNumber: number,
    searchWord: string,
    homePageId: string
  ) => {
    return axios.post('/learn/app/comprehensiveSearch.do', {
      curPage: pageNumber,
      numPerPage: 15,
      searchWord,
      // 登陆接口返回
      umId: UserStore.userId,
      // 版本号 后台同学要求用999
      ver: '999',
      appId: UserStore.appId,
      supportInteractive: 1,
      homePageId,
    })
  },
  searchItem: (pageNo: number, searchWord: string, tabId: number) => {
    return axios.get('/learn/app/clientapi/misc/search/flexSearch.do', {
      params: {
        curPage: pageNo,
        numPerPage: 15,
        homePageId: '',
        searchWord,
        // 登陆接口返回
        umId: userId,
        // 版本号
        ver: '999',
        //
        appId: UserStore.appId,
        tabId,
        supportInteractive: 1,
        sid: UserStore.getSid(),
      },
    })
  },

  // 企业课程 查看更多
  getEnterPriseListMore: (pageNumber: number, searchWord: string) => {
    return axios.get('/learn/app/searchMyCompanyCourse.do', {
      params: {
        curPage: pageNumber,
        homePageId: '',
        numPerPage: 15,
        searchWord,
      },
    })
  },

  // 直播 查看更多
  getLiveListMore: (
    pageNumber: number,
    searchWord: string,
    isSchoolLive?: boolean
  ) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/queryLiveRoomByPage.do'), {
      params: {
        liveType: isSchoolLive ? 99 : 1,
        pageNo: pageNumber,
        homePageId: '',
        pageSize: 15,
        supportInteractive: 1,
        keyword: searchWord,
        isSchoolLive: isSchoolLive || false,
      },
    })
  },
  // 短视频列表
  queryLittleVideoList: (params: IShortVideo) => {
    return axios.post(
      '/learn/app/clientapi/live/shortVideo/search/searchByKeyword.do',
      {
        ...params,
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 回放 查看更多
  getBackListMore: (pageNumber: number, searchWord: string) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/queryLiveRoomByPage.do'), {
      params: {
        liveType: 3,
        pageNo: pageNumber,
        homePageId: '',
        pageSize: 15,
        supportInteractive: 1,
        keyword: searchWord,
      },
    })
  },

  // 专题 查看更多
  getSeminarListMore: (pageNumber: number, searchWord: string) => {
    return axios.get('/learn/app/clientapi/home/subject/searchMoreSubject.do', {
      params: {
        pageNo: pageNumber,
        homePageId: '',
        pageSize: 15,
        supportInteractive: 1,
        searchWord,
      },
    })
  },
  // 面授班 查看更多
  getTrainListMore: (pageNumber: number, searchWord: string) => {
    return axios.get('/learn/app/clientapi/trainingclass/searchMoreClass.do', {
      params: {
        pageNo: pageNumber,
        homePageId: '',
        pageSize: 15,
        supportInteractive: 1,
        searchWord,
      },
    })
  },
  // 资讯 查看更多
  getInforListMore: (pageNumber: number, searchWord: string) => {
    return axios.get('/learn/app/clientapi/home/info/searchMoreInfo.do', {
      params: {
        pageNo: pageNumber,
        homePageId: '',
        pageSize: 15,
        supportInteractive: 1,
        searchWord,
      },
    })
  },
  // 文库 查看更多
  // getKnowledgeListMore: (pageNumber: number, searchWord: string) => {
  //   return axios.get('/learn/app/clientapi/home/subject/searchMoreSubject.do', {
  //     params: {
  //       pageNo: pageNumber,
  //       homePageId: '',
  //       pageSize: 15,
  //       supportInteractive: 1,
  //       searchWord,
  //     }
  //   })
  // },
  // 文件 查看更多
  // getFileListMore: (pageNumber: number, searchWord: string) => {
  //   return axios.get('/learn/app/clientapi/trainingclass/searchMoreClass.do', {
  //     params: {
  //       pageNo: pageNumber,
  //       homePageId: '',
  //       pageSize: 15,
  //       supportInteractive: 1,
  //       searchWord,
  //     }
  //   })
  // }
}
